import { render, staticRenderFns } from "./BuySubdomain.vue?vue&type=template&id=6280f736&scoped=true&"
import script from "./BuySubdomain.vue?vue&type=script&lang=js&"
export * from "./BuySubdomain.vue?vue&type=script&lang=js&"
import style0 from "./BuySubdomain.vue?vue&type=style&index=0&id=6280f736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6280f736",
  null
  
)

export default component.exports